import { getRequest, postRequest } from '../../services/httpService';

export function buildInitiateSSOUrl(redirectTo: string): string {
  return `pgta/initiate_sso?redirect_to=${encodeURIComponent(redirectTo)}`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function initiateSSO(redirectTo: string): Promise<{ status: number; data: any }> {
  const url = buildInitiateSSOUrl(redirectTo);
  return getRequest(url); // axios wrapper should return { status, data }
}



export function buildProxyURL(endpoint: string, method = 'GET'): string {
  return `pgta/proxy?url=${encodeURIComponent(endpoint)}&method=${method}`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function fetchViaProxy(endpoint: string, method = 'GET', ): Promise<{ status: number; data: any }> {
  const url = buildProxyURL(endpoint, method);
  return postRequest(url, {}, );
} 



export function buildInitiateSSOUrl2(redirectTo: string): string {
  return `https://stage-api.vidaisolutions.com/api/pgta/initiate_sso?redirect_to=${encodeURIComponent(redirectTo)}`;
}

type SSOResponse = {
  status: 'ok' | 'failed';
  location: string;
  msg: string;
};


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function initiateSSO2(redirectTo: string): Promise<SSOResponse> {
  const url = buildInitiateSSOUrl2(redirectTo);
  return getRequest(url); // axios wrapper should return { status, data }
}
